import React from 'react';
import PropTypes from 'prop-types';
import {
  Platform,
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  ActivityIndicator,
} from 'react-native';
import { Button } from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { FlatGrid } from 'react-native-super-grid';

import AORTypes from '../../types';
import { AppSyncClientAudit } from '../../backends/AppSyncClientAudit';
import GetPendingUsers from '../../q/audit/GetPendingUsers';
import UserApprove from '../../q/audit/UserApprove';
import UserDecline from '../../q/audit/UserDecline';
import PublisherBadge from '../../components/apps/PublisherBadge';
import styles from '../../styles';
import Publisher from '../../modules/data/Publisher';

class PendingUsers extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PendingUsers';

    this.handleDecline = this.handleDecline.bind(this);
    this.handleApprove = this.handleApprove.bind(this);
  }

  handleApprove(uuid) {
    const { onApprove } = this.props;

    onApprove(uuid)
      .then((result) => {
        console.log('onApprove() succeeded');
        console.log(result);
      })
      .catch((result) => {
        console.log('onApprove() failed');
        console.log(result);
      });
  }

  handleDecline(uuid) {
    const { onDecline } = this.props;

    onDecline(uuid)
      .then((result) => {
        console.log('onDecline() succeeded');
        console.log(result);
      })
      .catch((result) => {
        console.log('onDecline() failed');
        console.log(result);
      });
  }

  render() {
    const {
      users,
      userData,
    } = this.props;

    if (!userData) {
      return (
        <View
          style={{
            backgroundColor: 'white',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          <KeyboardAvoidingView
            style={[styles.form.container, {
              backgroundColor: 'white',
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            <View style={{
              flex: 1,
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
            }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 60,
                }}
              >
                {/* Choose the language here */}
                {/* <Text></Text> */}
              </View>
              {users.length < 1 ? (
                <View
                  style={{
                    flex: 1,
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Text>
                    No users queued for review.
                  </Text>
                </View>
              ) : (
                <ScrollView
                  style={{
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <FlatGrid
                    itemDimension={410} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
                    data={users}
                    renderItem={
                      ({ item }) => {
                        const publisher = Publisher.createFromData(item);

                        return (
                          <View
                            style={{
                              flexDirection: 'row',
                            }}
                          >
                            <View
                              style={{
                                flex: 1,
                                flexDirection: 'column',
                                // maxWidth: 300,
                              }}
                            >
                              <PublisherBadge publisher={publisher} />
                              <Text>
                                {publisher.data.desc}
                              </Text>
                            </View>
                            <View
                              style={{
                                flexDirection: 'column',
                              }}
                            >
                              <Button
                                title="Decline"
                                containerStyle={styles.button.secondaryContainer}
                                buttonStyle={styles.button.secondary}
                                disabledStyle={styles.button.secondaryDisabled}
                                titleStyle={styles.button.secondaryTitle}
                                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                                onPress={() => this.handleDecline(item.uuid)}
                              />
                              <Button
                                title="Approve"
                                containerStyle={styles.button.primaryContainer}
                                buttonStyle={styles.button.primary}
                                disabledStyle={styles.button.primaryDisabled}
                                titleStyle={styles.button.primaryTitle}
                                disabledTitleStyle={styles.button.primaryTitleDisabled}
                                onPress={() => this.handleApprove(item.uuid)}
                              />
                            </View>
                          </View>
                        );
                      }
                    }
                  />
                </ScrollView>
              )}
            </View>
          </KeyboardAvoidingView>
        </View>
      </View>
    );
  }
}

PendingUsers.defaultProps = {
  users: [],
  userData: null,
};

PendingUsers.propTypes = {
  users: PropTypes.arrayOf(AORTypes.User),
  userData: AORTypes.User,
  onApprove: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetPendingUsers, {
    props: (props) => {
      console.log('graphql returned: GetPendingUsers: ');
      console.log(props.data);

      if (!props.data.getPendingUsers) {
        return {
          users: [],
        };
      }
      return {
        users: props.data.getPendingUsers.items,
      };
    },
    options: (props) => ({
      variables: {
        lang: '*',
      },
      client: AppSyncClientAudit(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAudit(props.user),
  }),
  graphql(UserApprove, {
    props: (props) => ({
      onApprove: (uuid) => props.mutate({
        variables: {
          uuid,
        },
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetPendingUsers,
        variables: {
          lang: '*',
        },
        client: AppSyncClientAudit(props.user),
      }],
      client: AppSyncClientAudit(props.user),
    }),
  }),
  graphql(UserDecline, {
    props: (props) => ({
      onDecline: (uuid) => props.mutate({
        variables: {
          uuid,
        },
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetPendingUsers,
        variables: {
          lang: '*',
        },
        client: AppSyncClientAudit(props.user),
      }],
      client: AppSyncClientAudit(props.user),
    }),
  })
)(PendingUsers);
